export const THIRD_PARTY_KEY = 'thirdPartyInformation.thirdPartyDetails';
export const DATA_SUB_PROCESSOR_KEY = 'thirdPartyInformation.dataSubProcessors';
export const DATA_RETENTION_DURAION_MIN = 'dataRetention.retentionDurationInDays.min';
export const DATA_RETENTION_DURAION_MAX = 'dataRetention.retentionDurationInDays.max';
export const IS_DATA_PROCESSED = 'dataAccessAndStorage.appProcessEUDOutsideAtlassian';
export const IS_DATA_STORED = 'dataAccessAndStorage.appStoresEUDOutsideAtlassian';
export const IS_SAME_DATA_PROCESSED_STORED = 'dataAccessAndStorage.isSameDataProcessedAndStored';
export const TYPES_OF_DATA_STORED = 'dataAccessAndStorage.typesOfDataStored';
export const TYPES_OF_DATA_PROCESSED = 'dataAccessAndStorage.typesOfDataAccessed';